// extracted by mini-css-extract-plugin
export var header = "_gh-0";